/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CspUsersResponse } from '../model/cspUsersResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CspProxyOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get CSP Organization Users
     * Get users from CSP API with filtering and search capabilities. This proxy API returns all matching users in a single response without pagination. Supports filtering by role type (organization/service), specific role names, service types (VCDR/VMCFS/VCDS), and user search.
     * @param orgId Organization identifier
     * @param roleType Role type filter for CSP users - \&quot;service\&quot; or \&quot;organization\&quot;
     * @param roleName Specific role name to filter by
     * @param serviceType Service Type
     * @param userSearch Search by firstName, username, acct, or email
     * @param countOnly Return only count (default true)
     * @param expandCompleteProfile Return complete user profile with all fields (default true). When false, returns only username, firstName, lastName, email, and acct fields.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCspOrgUsersOperator(orgId: string, roleType?: 'organization' | 'service', roleName?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', userSearch?: string, countOnly?: boolean, expandCompleteProfile?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<CspUsersResponse>;
    public getCspOrgUsersOperator(orgId: string, roleType?: 'organization' | 'service', roleName?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', userSearch?: string, countOnly?: boolean, expandCompleteProfile?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CspUsersResponse>>;
    public getCspOrgUsersOperator(orgId: string, roleType?: 'organization' | 'service', roleName?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', userSearch?: string, countOnly?: boolean, expandCompleteProfile?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CspUsersResponse>>;
    public getCspOrgUsersOperator(orgId: string, roleType?: 'organization' | 'service', roleName?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', userSearch?: string, countOnly?: boolean, expandCompleteProfile?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getCspOrgUsersOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>roleType, 'roleType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>roleName, 'roleName');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>userSearch, 'user-search');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>countOnly, 'countOnly');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>expandCompleteProfile, 'expandCompleteProfile');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/csp-proxy/orgs/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/users`;
        return this.httpClient.request<CspUsersResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
